export default function Hero() {
  return (
    <section
      className="w-full flex items-center justify-center bg-white"
      style={{ paddingTop: "148px", paddingBottom: "48px" }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 md:px-10">
        {/* Hero Card */}
        <div
          className="relative overflow-hidden rounded-2xl md:rounded-3xl"
          style={{ minHeight: "520px" }}
        >
          {/* Background Image */}
          <img
            src="https://storage.readdy-site.link/project_files/761f9a53-7d6d-4162-b8bb-9f472548236c/8f28d6ee-ff1c-4705-9374-b824c1915188_escritorio-lupepsa.png?v=4bf24948fa357b4f674132fe31fb14df"
            alt="Escritório Lupepsa & Marconatto"
            className="absolute inset-0 w-full h-full object-cover object-top"
            style={{ filter: "blur(2px)", transform: "scale(1.04)" }}
          />

          {/* Dark overlay gradient */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#3D0608]/90 via-[#550A0D]/75 to-[#6E0C10]/40" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#3D0608]/60 via-transparent to-transparent" />

          {/* Decorative left golden border */}
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-[#E3B24A]/80 to-transparent z-10 rounded-l-3xl" />

          {/* Content */}
          <div className="relative z-10 flex items-center h-full" style={{ minHeight: "520px" }}>
            <div className="px-8 md:px-16 py-14 md:py-16 max-w-2xl">
              {/* Top ornament */}
              <div className="flex items-center gap-3 mb-6">
                <div className="h-px w-10 bg-[#E3B24A]/70" />
                <span className="text-[#E3B24A] font-body text-xs tracking-[0.3em] uppercase font-medium">
                  Advocacia &amp; Consultoria
                </span>
              </div>

              {/* H1 */}
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-5">
                Advocacia estratégica com{" "}
                <em className="text-[#E3B24A] not-italic">excelência</em>
                <br />
                e sofisticação.
              </h1>

              {/* Divider */}
              <div className="flex items-center gap-3 my-6">
                <div className="h-px w-8 bg-[#E3B24A]/50" />
                <div className="w-1.5 h-1.5 rounded-full bg-[#E3B24A]" />
                <div className="h-px w-8 bg-[#E3B24A]/50" />
              </div>

              {/* Subtitle */}
              <p className="font-body text-[#F2D27A]/85 text-base md:text-lg leading-relaxed">
                Atuação jurídica especializada para proteger seus direitos
                <br className="hidden md:block" />
                com segurança e eficiência.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
